import { ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const routeGroupsProjectSettingsWorkflowSchemeConfigRoute = {
	group: ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK,
	name: `${ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-workflow-scheme-config`,
	path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
	exact: true,
};
